/**
 * SEO Meta Tag Manager
 * 
 * This script checks if a product, page or article should have the noindex meta tag
 * based on its metafields and removes it if it doesn't meet the criteria.
 */
document.addEventListener('DOMContentLoaded', function() {


  // Function to check if we're on a product, page, or article
  function checkPageType() {
    const bodyClasses = document.body.className;

    
    if (bodyClasses.includes('template-product') || 
        bodyClasses.includes('template-page') || 
        bodyClasses.includes('template-article') || 
        bodyClasses.includes('template-collection')) {

      return {
        isRelevant: true,
        type: bodyClasses.includes('template-product') ? 'product' : 
              bodyClasses.includes('template-page') ? 'page' : 
              bodyClasses.includes('template-article') ? 'article' : 'collection'
      };
    }

    return { isRelevant: false, type: null };
  }

  // Function to check if a noindex robots meta tag is present
  function shouldHaveNoIndex() {
    // Look for any robots meta tag that contains 'noindex' in its content
    const metaTags = document.querySelectorAll('meta[name="robots"]');
    let hasNoIndex = false;
    
    metaTags.forEach(tag => {
      const content = tag.getAttribute('content');
      if (content && content.includes('noindex')) {
        hasNoIndex = true;
      
      }
    });
    

    return hasNoIndex;
  }

  // Function to check if there are other robots meta tags
  function hasOtherRobotsTag() {
    const metaTags = document.querySelectorAll('meta[name="robots"]');

    
    if (metaTags.length > 0) {
      metaTags.forEach((tag, index) => {

      });
    }
    
    return metaTags.length > 1;
  }

  const pageInfo = checkPageType();
  const hasNoIndex = shouldHaveNoIndex();
  const hasMultipleRobotsTags = hasOtherRobotsTag();
  


  // Function to remove noindex meta tags
  function removeNoIndexMetaTags() {
    const metaTags = document.querySelectorAll('meta[name="robots"]');
    let removedCount = 0;
    
    metaTags.forEach(tag => {
      const content = tag.getAttribute('content');
      if (content && content.includes('noindex')) {
      
        tag.parentNode.removeChild(tag);
        removedCount++;
      }
    });
    
    return removedCount;
  }
  
  // Function to check if the metafield seo.noindex is FALSE
  function checkMetafieldStatus() {
    // Attempt to get the metafield from the body
    let metafieldValue = null;
    
    // Since the attributes are on the body, we simplify the logic
    if (pageInfo.type === 'product') {
      const metafieldAttr = document.body.getAttribute('data-product-metafield-seo-noindex');
      if (metafieldAttr !== null) {
        metafieldValue = metafieldAttr === 'true';
      
      }
    } else if (pageInfo.type === 'page') {
      const metafieldAttr = document.body.getAttribute('data-page-metafield-seo-noindex');
      if (metafieldAttr !== null) {
        metafieldValue = metafieldAttr === 'true';
      
      }
    } else if (pageInfo.type === 'article') {
      const metafieldAttr = document.body.getAttribute('data-article-metafield-seo-noindex');
      if (metafieldAttr !== null) {
        metafieldValue = metafieldAttr === 'true';
       
      }
    } else if (pageInfo.type === 'collection') {
      const metafieldAttr = document.body.getAttribute('data-collection-metafield-seo-noindex');
      if (metafieldAttr !== null) {
        metafieldValue = metafieldAttr === 'true';
       
      }
    }
    
  
    return metafieldValue;
  }
  
  // If we're on a relevant page
  if (pageInfo.isRelevant) {
    const metafieldValue = checkMetafieldStatus();
    
    // If the metafield is explicitly FALSE or doesn't exist, and there's a noindex meta, remove it
    if ((metafieldValue === false || metafieldValue === null) && hasNoIndex) {
    
      const removedCount = removeNoIndexMetaTags();

    } 
    // If the metafield is TRUE and no noindex meta, do nothing (already configured correctly)
    else if (metafieldValue === true && !hasNoIndex) {
    
    }
    // If the metafield is TRUE and there is a noindex meta, it's correct
    else if (metafieldValue === true && hasNoIndex) {
     
    }
    // If the metafield is FALSE or doesn't exist and there is no noindex meta, it's correct
    else if ((metafieldValue === false || metafieldValue === null) && !hasNoIndex) {
    
    }
  } else {
   
  }
});
